<template>
  <v-dialog
    v-model="showingDeleteRegionModal"
    width="auto"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{$t('¿Estás seguro de eliminar la region')}} '{{ region.name }}'?
      </v-card-title>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn 
          color="tertiary" 
          outlined 
          @click="close()"
        >
          {{$t('Cancelar')}}
        </v-btn>         
        <v-btn
          outlined 
          color="error"
          @click="deleteRegion()"
        >
          {{$t('Eliminar')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data: () => {
    return {
      showingDeleteRegionModal: false,
      region: {}
    }
  },

  methods: {
    openModal(region) {
      this.showingDeleteRegionModal = true
      this.region = region
    },

    close() {
      this.showingDeleteRegionModal = false
    },

    async deleteRegion() {
      try {
        const response = await this.$api.deleteRegion(this.region.id)

        this.$emit('reload-region-list')
        this.close()
      } catch(e) {
        console.log(e)
      }
    }
  }
}
</script>